export const botName = 'SquadTest1Bot'
export const defaultColor = 'colorHexLight'
